import {
  Component,
  EventEmitter,
  input,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  QuoteDescriptionPayload,
  RfeAction,
  RFQ_QUOTE_INDICATIVE,
  RfqQuote,
  Vol
} from '@approot/models';
import { AdminService } from '@approot/services';
import {
  quoteActionAnimation,
  quoteEnterAnimation
} from '@approot/shared/animations';
import { formatPremium } from '@approot/utilities';
import { SingleProviderDXState } from '@approot/widgets/rfq/rfq-container/rfq-tab/rfq-setup/rfq-setup.service';
import { Throttle } from 'lodash-decorators';

@Component({
  selector: 'app-rfq-quote',
  templateUrl: './rfq-quote.component.html',
  styleUrls: ['./rfq-quote.component.scss'],
  animations: [quoteActionAnimation, quoteEnterAnimation]
})
export class RfqQuoteComponent implements OnChanges {
  @Input() public row: RfqQuote;
  @Input() public index: number;
  @Input() public position: 'left' | 'right';
  @Input() public side: 'bid' | 'offer';
  @Input() public showVolSpreadLine = false;
  @Input() public frozenQuote: boolean;
  @Input() public currentTimestamp: number;
  @Input() public showInlineVol = false;
  @Input() public showBank = false;
  @Input() public rfqRunning = false;
  @Input() public showTopBookOnly = false;
  @Input() public volBased: boolean;
  @Input() public rfqRequestActionStatus: RfeAction;
  @Input() public hedge: string;
  @Input() public forwardPointsMultiplier: number;
  @Input() public cross: string;
  @Input() public baseCurrency: string;
  @Input() public termCurrency: string;
  @Input() public termPair: string;
  @Input() public animateQuotes = false;
  @Input() public disabled = false;
  @Input() public indicativePremiumStyle: string;
  @Input() public pipsHighlightedIndices: number[] = [];
  @Input() public useSingleProviderDetailedView = false;
  @Input() public customHedgeAmount: any;
  @Input() public enableCustomHedgeAmount: boolean;
  @Input() public parent = '';
  @Input() public nonDxExists: boolean;
  public singleProviderDXState = input<SingleProviderDXState>(null);
  @Output() public requestEmitter = new EventEmitter<RfqQuote>();
  @Output() public showDescription =
    new EventEmitter<QuoteDescriptionPayload>();
  @Output() public ping = new EventEmitter<void>();
  public isNaN = isNaN;
  public formatPremium = formatPremium;
  public showVols = { left: true, right: true };

  constructor(private adminService: AdminService) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.row && changes.row.currentValue) {
      this.showVols = {
        left: !allVolZero(this.row?.vol?.['left']),
        right: !allVolZero(this.row?.vol?.['right'])
      };
    }
  }

  @Throttle(500)
  public hedgeCustomAmountMismatch() {
    // Not implemented in b/e yet
    return false;
    // if (!this.enableCustomHedgeAmount) {
    //   return false;
    // }
    // const a = Math.round(this.row?.hedge?.amount);
    // const b = Math.round(+this.customHedgeAmount);
    // if (this.row?.hedge?.amount == null) {
    //   return false;
    // }
    // if (this.customHedgeAmount === '' || this.isNaN(+this.customHedgeAmount)) {
    //   return false;
    // }
    // return a !== b;
  }

  public doShowDescription(row: RfqQuote, side: 'bid' | 'ask'): void {
    this.showDescription.emit({
      row,
      side
    });
  }

  public pingOnce(): void {
    this.ping.emit();
  }

  public rfeRequest(quote: RfqQuote): void {
    this.requestEmitter.emit(quote);
  }

  public rfeRequestKeydown(event: KeyboardEvent, quote: RfqQuote): void {
    if (event.key === 'Enter') {
      this.rfeRequest(quote);
    }
  }

  public maybeHideIndicativeRow(): boolean {
    if (this.row.status === RFQ_QUOTE_INDICATIVE) {
      return !this.adminService.medusaUser?.display_indications;
    } else {
      return false;
    }
  }

  public invertDirection(dir: 'Buy' | 'Sell'): 'Buy' | 'Sell' {
    return dir === 'Buy' ? 'Sell' : 'Buy';
  }
}

function allVolZero(vols: Vol[]): boolean {
  if (!vols || vols.length === 0) {
    return true;
  }
  return vols.every(vol => vol.value === 0);
}
